import React, { Component, ReactNode } from 'react'
import { CSSTransition } from 'react-transition-group'
import './Transition.css'

type TransitionType = 'flash' | 'fade'

interface Props {
  type?: TransitionType
  visible: boolean
  children: ReactNode
}

export default class Transition extends Component<Props> {
  get transitionClasses () {
    switch (this.props.type) {
      case 'flash':
        return {
          enter: 'animate__animated',
          enterActive: 'animate__flash',
          exit: 'fade-exit',
          exitActive: 'fade-exit-active'
        }
      default:
        return 'fade'
    }
  }

  render () {
    return (
      <CSSTransition
        in={this.props.visible}
        timeout={500}
        unmountOnExit
        classNames={this.transitionClasses}>
        {this.props.children}
      </CSSTransition>
    )
  }
}
